import type { ContentType } from '../../content/models/content-type.enum';

export enum AccountType {
  LEGACY = 'LEGACY',
  NEW = 'NEW',
  NONE = 'NONE',
}

export enum LegacyAuthModalState {
  LOGIN = 'LOGIN',
  CREATE_ACCOUNT = 'CREATE_ACCOUNT',
  RESET_PASSWORD = 'RESET_PASSWORD',
  VERIFY_EMAIL = 'VERIFY_EMAIL',
}

export interface AuthenticationRequest {
  state: LegacyAuthModalState;
  allowedStates?: LegacyAuthModalState[];
  returnToUrl?: string;
  rejectUrl?: string;
  terms?: string;
  preventLoad?: boolean;
}

export interface AuthenticationResult {
  success: boolean;
  loadUrl?: string;
  rejectUrl?: string;
  termsAccepted?: boolean;
  optInToMarketingEmails?: boolean;
}

export enum LoginType {
  CUSTOMER = 'CUSTOMER',
  WALLET = 'WALLET',
}

export interface CheckAuthenticationRequest {
  loginTypes?: LoginType[];
  keyId?: string;
  contentType?: ContentType;
  contentId?: string;
  allContent?: boolean;
}

export interface CheckAuthenticationResponse {
  authenticated: boolean;
  loginTypes: LoginType[];
}

export interface AuthenticationFormResponse {
  type: AuthenticationFormResponseType;
  response?: Response;
  redirectUrl?: string;
  successMessage?: string;
  errorCode?: AuthenticationFormErrorCode;
  errorMessage?: string;
  error: any;
}

export enum AuthenticationFormResponseType {
  SUCCESS = 'SUCCESS',
  ERROR_CODE = 'ERROR_CODE',
}

export enum AuthenticationFormErrorCode {
  LOGIN_REQUIRED = 'login_required',
  INVALID_CREDENTIALS = 'invalid_credentials',
  ACCOUNT_ALREADY_EXISTS = 'account_already_exists',
  INVALID_EMAIL = 'invalid_email',
  WEAK_PASSWORD = 'weak_password',
  MISSING_FIELDS = 'missing_fields',
  INVALID_NAME = 'invalid_name',
  PASSWORD_MISMATCH = 'password_mismatch',
  MISSING_EMAIL = 'missing_email',
  EMAIL_NOT_FOUND = 'email_not_found',
  EMAIL_VERIFY = 'email_verify',
  CAPTCHA_CHALLENGE = 'captcha_challenge',
  UNKNOWN_ERROR = 'unknown_error',
}

export interface CustomerResponse {
  customerId: string;
  email: string;
  firstName: string;
  lastName: string;
  hasAccount: boolean;
}
